import { Text } from '@avanta/shared/components/Text';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import { SEARCH_PSYCHOLOGISTS_KEY_PREFIX } from '../constants';
import { type PsychologistSearchResultsProps } from '../types';
import { PsychoCard } from './PsychoCard';
import { PsychologistStepSkeleton } from './PsychologistStepSkeleton';

export const PsychologistSearchResults = ({
  psychologists,
  isLoading,
  onPsychologistSelect,
}: PsychologistSearchResultsProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);

  if (isLoading) return <PsychologistStepSkeleton />;

  if (!psychologists.length) {
    return (
      <Text variant="text-sm-regular" className="text-denim-500">
        {t(`${SEARCH_PSYCHOLOGISTS_KEY_PREFIX}notFound`)}
      </Text>
    );
  }

  return (
    <>
      {psychologists.map(psychologist => (
        <PsychoCard
          key={psychologist.id}
          psychologist={psychologist}
          onClick={() => onPsychologistSelect(psychologist)}
        />
      ))}
    </>
  );
};
